/** @jsxImportSource @emotion/react */
import { CSSProperties } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import TwoColumnLayout from '../TwoColumn/TwoColumnLayout';

export type LayoutType = 'None' | 'TwoColumn';

interface PropsShape {
    data: any;
    layout: LayoutType;
    parentWidgetInstanceId: string;
    leftColumnOptions: CSSProperties;
    rightColumnOptions: CSSProperties;
}

const Layout = (props: PropsShape) => {
    const { data, layout, parentWidgetInstanceId, leftColumnOptions, rightColumnOptions } = props;
    const { Placeholder } = commonHooks.useAppContext();

    switch (layout) {
        case 'None':
            return (
                <Placeholder
                    contentPlaceHolderId="page-children"
                    parentWidgetInstanceId={parentWidgetInstanceId}
                    data={data}
                />
            );
        case 'TwoColumn':
            return (
                <div className="two-column">
                    <TwoColumnLayout
                        data={data}
                        widgetInstanceId={parentWidgetInstanceId}
                        leftColumnOptions={leftColumnOptions}
                        rightColumnOptions={rightColumnOptions}
                    />
                </div>
            );
        default:
            return (
                <Placeholder
                    contentPlaceHolderId="page-children"
                    parentWidgetInstanceId={parentWidgetInstanceId}
                    data={data}
                />
            );
    }
};

export default Layout;
